import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom-v5-compat";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import App from "onsite_app";
import en from "../../frontend/welcome/locales/en.json";
import l from "../../frontend/onsite_app/locales/en.json";
import onsite_nz from "../../frontend/onsite_app/locales/en-NZ.json";
import onsite_au from "../../frontend/onsite_app/locales/en-AU.json";
import onsite_gb from "../../frontend/onsite_app/locales/en-GB.json";
import "../styles/Welcome.css";
import Welcome from "../welcome";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    resources: {
      en: { translations: en },
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "translations",
    ns: "translations",
  });

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <BrowserRouter>
      <Welcome />
    </BrowserRouter>,
    document.body.appendChild(document.createElement("div"))
  );
});
